import { useState, useEffect } from "react";
import { BMIByDepartmentStyled } from "./styled";
import { Blocks, Typographys, Inputs, Skeleton } from "components";
import moment from "moment";

const BMIByDepartment = ({ data, fetchData }) => {
  const [_data, _setData] = useState();
  const [_loadSkeleton, _setLoadSkeleton] = useState(false);

  useEffect(() => {
    if (data) {
      _setData(data);
    }
  }, [data]);

  const fetchDataApi = async (stat_date) => {
    let res = await fetchData(stat_date);
    if (res) {
      _setData(res);
      _setLoadSkeleton(false);
    } else {
      _setLoadSkeleton(false);
    }
  };
  const handleChangDate = (e) => {
    _setLoadSkeleton(true);
    fetchDataApi(moment(e).startOf("months").format("YYYY-MM-DD"));
  };

  return (
    <BMIByDepartmentStyled>
      <Blocks.Box
        theme_standard_box
        paddingTop="23px"
        paddingRight="20px"
        paddingBottom="23px"
        paddingLeft="20px"
      >
        <div className="bmi_department_head_container">
          <div className="bmi_department_head_col_start">
            <div className="bmi_department_head_col">
              <Typographys.TopBottom
                theme_left_align
                label="BMI แบ่งตามแผนกในบริษัท"
                labelBottom="BMI by department"
                fontSizeLabelButtom="14px"
              />
            </div>
            <div className="bmi_department_head_col">
              <div className="chart_status_block">
                <div className="item_status ml_29">
                  <Blocks.BoxWellbeing
                    theme_average_box_well_being
                    label="สมส่วน"
                    labelBottom="Normal weight"
                    bgColor="#8AC47F"
                    showRound
                  />
                </div>
                <div className="item_status">
                  <Blocks.BoxWellbeing
                    theme_average_box_well_being
                    label="เกินมาตรฐาน"
                    labelBottom="Overweight"
                    bgColor="#62B4E9"
                    showRound
                  />
                </div>
                <div className="item_status ml_11">
                  <Blocks.BoxWellbeing
                    theme_average_box_well_being
                    label="ต่ำกว่ามาตรฐาน"
                    labelBottom="Underweight"
                    bgColor="#654C96"
                    showRound
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="bmi_department_head_col">
            <div className="filter_block">
              <div className="item_filter w_200">
                <Inputs.InputDatePikerCustom
                  theme_standard_date_picker_custom
                  dateFormat="MM/yyyy"
                  onChangeCustom={(e) => handleChangDate(e)}
                  showMonthYearPicker
                  showFullMonthYearPicker
                  initialValues={new Date()}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="chart_container">
          {!_data || _data.length === 0 ? (
            <div className="label_empty">ยังไม่มีข้อมูล</div>
          ) : _loadSkeleton ? (
            <Skeleton.GraphSkeleton height="100px" />
          ) : (
            _data.map((d, h) => (
              <div key={h} className="chart_wrap">
                {d && (
                  <div className="c_row_2_col">
                    {d.map((e, i) => (
                      <div key={i} className="bar_item">
                        <div className="label">{e.name}</div>
                        <div className="percent_bar">
                          {e.data.map((e2, j) => (
                            <div
                              key={j}
                              className="stack_item"
                              style={{
                                width: `${e2.percent}%`,
                                backgroundColor: COLORS_GRAPH[j],
                              }}
                            >
                              {e2.percent !== 0 && `${e2.percent}%`}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </Blocks.Box>
    </BMIByDepartmentStyled>
  );
};

const COLORS_GRAPH = ["#8AC47F", "#62B4E9", "#654c96"];

export default BMIByDepartment;
